<yat-button-close-modal id="c2b12c50-75ba-4a89-b569-7f438570b35d" *ngIf="showCloseIcon" (clickMethod)="closeModal()"> </yat-button-close-modal>
<div class="mod-content">
  <div class="mod-header-part" *ngIf="header !== undefined">
    <div class="mod-header">
      <h2>
        <yat-icon id="4d802b31-6721-49da-99d4-0afc82d8df03" *ngIf="icon" [name]="icon" class="ico-title {{ iconClass }}"></yat-icon>
        <transloco
          id="1093d57c-29e6-4dde-a91b-86e2bddfb35a"
          *ngIf="getHeaderAsTranslationId() as headerId; else stringHeader"
          [key]="headerId.key"
          [params]="headerId.params"
          [scope]="headerId.scope"></transloco>
        <ng-template #stringHeader>{{ header }}</ng-template>
      </h2>
      <yat-tooltip-info-icon id="a7daadb6-d4bc-46c9-95b4-2511c0c922f8" *ngIf="tooltip" [tooltipContent]="tooltip"> </yat-tooltip-info-icon>
    </div>
    <yat-notification-outlet id="41b30ce3-2563-4fcd-acb8-abb76f0e951f" *ngIf="showNotifications$ | async"></yat-notification-outlet>
  </div>
  <div class="mod-body">
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </div>
  <div class="mod-footer">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </div>
</div>
